export const scrollToRef = (ref) => {
    var _a, _b, _c, _d;
    const { body } = document;
    const maxHeightOfDropdown = 300;
    const offsetParentTop = ((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.offsetParent) === null || _b === void 0 ? void 0 : _b.offsetTop) || 0;
    const screenInnerHeight = window.innerHeight;
    // How far from the top the ref elem is
    const refFromTop = (((_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0) + offsetParentTop;
    // How far we've scrolled - counted from the top of the page
    const scrolledFromTop = window.scrollY ||
        window.pageYOffset ||
        body.scrollTop + (((_d = document === null || document === void 0 ? void 0 : document.documentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || 0);
    // Calculating the viewport end
    const viewportEnd = scrolledFromTop + screenInnerHeight;
    // Calculating the (maximum) dropdown end
    const end = refFromTop + maxHeightOfDropdown;
    // Calculating if the maximum height of the dropdown isn't fully shown in viewport. If not, the scroll to function is triggered
    if (refFromTop >= scrolledFromTop && viewportEnd <= end) {
        window.scrollTo({
            top: scrolledFromTop + maxHeightOfDropdown,
            left: 0,
            behavior: 'smooth',
        });
    }
};
//# sourceMappingURL=scrollToRef.js.map